export default "__VITE_ASSET__DIL9Y7Av__"